import Setting from './components';

export default Setting;
